import { useTranslation } from "react-i18next"

/** The session flag is authoritative, independently of the current config. */
export function MemoryOffTransferredNotice({ transferred }: { transferred: boolean }) {
  const { t } = useTranslation()
  if (!transferred) return null
  return (
    <p className="text-muted-foreground px-4 py-2 text-sm" role="status">
      {t("personalization.memoryPanel.prism.memoryOffTransferred")}
    </p>
  )
}
